const ActionType = {
  CREATE: 'Create',
  UPDATE: 'Update',
};

export default ActionType;
